import React,{useState,useEffect} from "react";
import {
    CircularProgress,
    Grid,
    IconButton,
    Paper,
    Table,
    TableBody, TableCell, tableCellClasses,
    TableContainer,
    TableHead,
    TableRow
} from "@mui/material";
import {styled} from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import axios from "axios";
import Appbar from "../Appbar";
const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const Showlog=({isMobile})=>{
    const [logList , setLogList] = useState([]);
    const [loading , setLoading] = useState(true);
    useEffect(()=>{
        axios.get("https://app.zhivay.com/api/get_log.php")
            .then(response=>{
                if (response.status === 200) {
                    setLogList(response.data);
                    setLoading(false);
                }
            })
            .catch(error=>{
                console.log(error);
                setLoading(false);
            })
    },'')
    return(
        <div style={{width:!isMobile ? "calc(100% - 240px)" : ""}}>
            <Appbar isMobile={isMobile}/>
            <Grid
                container
                sx={{direction:"rtl",padding:1}}
                direction="row"
                justifyContent="center"
                alignItems="center">
                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 250,maxHeight:'80%',overflowY:'auto',}} className='tbl-pishfactor'>
                        <TableHead>
                            <TableRow>
                                <StyledTableCell align="right">کاربر</StyledTableCell>
                                <StyledTableCell align="right">عملیات</StyledTableCell>
                                <StyledTableCell align="right">تاریخ</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {logList.map(items => (
                                <StyledTableRow
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <StyledTableCell align="right">{items.username}</StyledTableCell>
                                    <StyledTableCell sx={{direction:"ltr"}} align="right">{items.text}</StyledTableCell>
                                    <StyledTableCell sx={{direction:"ltr"}} align="right">{items.date}</StyledTableCell>
                                </StyledTableRow >
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
            <Dialog
                open={loading}
                scroll="paper">
                <CircularProgress sx={{margin:2}} />
            </Dialog>
        </div>
    )
}
export default Showlog;